// 由 app/scripts/dump-v2-geometry.ts 生成（deno），请勿手改。
// 源：supabase/functions/_shared/pptx/v2/layouts/*.ts 的 GEO + skin.ts 的 resolveSkin。
// 本文件提交 git（Pages 构建环境无 deno）；后端版式/皮肤改动后需重跑 dump 脚本。

export const V2GEO: Record<string, Record<string, unknown>> = {
  "kpi-hero": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "content": {
      "top": 2.35,
      "bottom": 6.7
    },
    "colGap": 0.4,
    "numH": 1.15,
    "labelGap": 0.12,
    "labelH": 0.55,
    "maxBarH": 2,
    "barWRatio": 0.62,
    "minBarRatio": 0.3,
    "flatBarH": 1.2
  },
  "bar-chart": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.2,
      "bottom": 6.85
    },
    "labelW": 3,
    "labelGap": 0.25,
    "valueGap": 0.12,
    "valueW": 1.3,
    "rowGap": 0.22,
    "barHRatio": 0.58,
    "minBarRatio": 0.04
  },
  "ledger": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "table": {
      "top": 2.15,
      "bottom": 6.85
    },
    "nameW": 4.6,
    "noteW": 2.4,
    "valueW": 2.6,
    "leaderGap": 0.2,
    "maxRowH": 0.85
  },
  "duo-compare": {
    "titleY": 0.85,
    "titleH": 0.75,
    "divX": 6.6665,
    "divTop": 1.85,
    "divBottom": 6.7,
    "colW": 5.3,
    "colPad": 0.7,
    "headY": 1.95,
    "headH": 0.42,
    "itemY0": 2.6,
    "itemH": 0.98,
    "bullet": 0.09,
    "bulletPad": 0.3,
    "maxItems": 4
  },
  "timeline-h": {
    "titleY": 0.85,
    "titleH": 0.75,
    "axisY": 3.95,
    "axisH": 0.02,
    "node": 0.16,
    "labelMaxW": 2.2,
    "labelPad": 0.15,
    "aboveTitleY": 2.5,
    "belowTitleY": 4.45,
    "descOff": 0.45,
    "descH": 0.75,
    "maxNodes": 6
  },
  "timeline-v": {
    "titleY": 0.85,
    "titleH": 0.75,
    "axisX": 0.85,
    "axisTop": 1.95,
    "axisBottom": 6.55,
    "node": 0.16,
    "textX": 1.35,
    "textW": 5.6,
    "nodeTitleH": 0.4,
    "splitX": 7.7,
    "kpiX": 8.1,
    "kpiW": 4.56,
    "kpiY": 2.5,
    "kpiH": 1.25,
    "kpiLabelY": 3.85,
    "kpiLabelH": 0.6,
    "maxNodes": 6
  },
  "cards": {
    "titleY": 0.98,
    "titleH": 0.72,
    "subY": 1.74,
    "subH": 0.4,
    "cardY": 2.3,
    "cardH": 4.2,
    "padX": 0.32,
    "numY": 0.3,
    "ctY": 0.85,
    "ctH": 0.65,
    "ddY": 1.6,
    "ddPad": 0.3
  },
  "matrix": {
    "titleY": 0.98,
    "titleH": 0.72,
    "subY": 1.74,
    "subH": 0.4,
    "gridY": 2.3,
    "gridBottom": 6.9,
    "cols": 3,
    "gap": 0.25,
    "padX": 0.26,
    "padTop": 0.24,
    "ctH": 0.45,
    "ddY": 0.78,
    "ddPad": 0.2
  },
  "image-text": {
    "textW": 4.7,
    "gap": 0.4,
    "topY": 1.05,
    "bottomY": 6.9,
    "titleH": 1.15,
    "subY": 2.3,
    "subH": 0.45,
    "bulletsY": 2.95,
    "bulletGap": 0.92,
    "markerSize": 0.09,
    "markerPad": 0.3
  },
  "perceptual-map": {
    "titleY": 0.95,
    "titleH": 0.75,
    "plotX": 2.4165,
    "plotY": 1.95,
    "plotW": 8.5,
    "plotH": 5.2,
    "axisLblW": 1.6,
    "axisLblH": 0.34,
    "pointSize": 0.16,
    "minDist": 0.35,
    "gapW": 1.5,
    "gapH": 0.9
  },
  "quad-matrix": {
    "titleY": 0.95,
    "titleH": 0.75,
    "gridTop": 2.35,
    "gridBottom": 6.9,
    "leftAxisW": 0.6,
    "cellGap": 0.08,
    "padX": 0.22,
    "padTop": 0.18,
    "cellTitleH": 0.42,
    "descY": 0.64,
    "starsY": -0.42,
    "starsH": 0.3,
    "starGlyph": "■",
    "starSize": 11
  },
  "pyramid": {
    "titleY": 0.95,
    "titleH": 0.75,
    "pyramidX": 0.67,
    "pyramidW": 5.5,
    "topY": 2.35,
    "layerH": 0.9,
    "layerGap": 0.06,
    "topWidthRatio": 0.3,
    "noteGap": 0.3,
    "noteH": 0.8
  },
  "grid-table": {
    "titleY": 0.95,
    "titleH": 0.75,
    "tableTop": 2.3,
    "tableBottom": 6.9,
    "rowHeadW": 2.5,
    "headH": 0.52,
    "maxRowH": 1.1,
    "cellPadX": 0.18,
    "cellPadY": 0.1,
    "markSize": 0.14,
    "tagW": 0.7,
    "tagH": 0.24
  },
  "waterfall": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.2,
      "bottom": 6.55
    },
    "labelH": 0.32,
    "barWRatio": 0.5
  },
  "gantt": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.55,
      "bottom": 6.85
    },
    "labelW": 2.9,
    "labelGap": 0.25,
    "tickH": 0.4,
    "laneHeadH": 0.38,
    "minRowH": 0.38,
    "barHRatio": 0.52
  },
  "funnel": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.35,
      "bottom": 6.75
    },
    "minBarRatio": 0.06,
    "barHRatio": 0.68,
    "nameW": 1.7,
    "valW": 1.5,
    "leadGap": 0.18,
    "minInlineW": 1.15
  },
  "dumbbell": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.35,
      "bottom": 6.75
    },
    "nameW": 2.2,
    "nameGap": 0.25,
    "labelW": 1.15,
    "labelGap": 0.1,
    "dotD": 0.16,
    "heroBarW": 0.07,
    "rowGap": 0.3
  },
  "bullet": {
    "title": {
      "x": 0.67,
      "y": 0.95,
      "w": 11.993,
      "h": 1
    },
    "chart": {
      "top": 2.35,
      "bottom": 6.75
    },
    "labelW": 2.2,
    "labelGap": 0.25,
    "valW": 1.25,
    "bandH": 0.34,
    "rowGap": 0.42,
    "passAt": 0.6,
    "goodAt": 0.85
  }
};

export interface V2Skin {
  style: string; bg: "paper" | "ink" | "accent";
  page: string; text: string; sub: string; hairline: string;
  accent: string; accentOn: string; accentOnBold: boolean;
  fontHead: string; fontBody: string; fontHero: string; fontMono: string;
  scale: { coverTitle: number; pageTitle: number; dataHero: number; sectionHead: number; body: number; caption: number; meta: number };
  radius: number; serifHead: boolean;
  ruleW: number;
  blush: string;
  pageDeep?: string;
  theme: Record<string, unknown>;
}

export const V2SKINS: Record<string, V2Skin> = {
  "swiss-ikb:paper": {
    "style": "swiss",
    "bg": "paper",
    "page": "#FAFAF8",
    "text": "#0A0A0A",
    "sub": "#737373",
    "hairline": "#D4D4D2",
    "accent": "#002FA7",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-ikb",
      "style": "swiss",
      "name": "克莱因蓝",
      "accent": "#002FA7",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-ikb:ink": {
    "style": "swiss",
    "bg": "ink",
    "page": "#0A0A0A",
    "text": "#FAFAF8",
    "sub": "#D4D4D2",
    "hairline": "#737373",
    "accent": "#002FA7",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-ikb",
      "style": "swiss",
      "name": "克莱因蓝",
      "accent": "#002FA7",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-ikb:accent": {
    "style": "swiss",
    "bg": "accent",
    "page": "#002FA7",
    "text": "#FFFFFF",
    "sub": "#FFFFFF",
    "hairline": "#FFFFFF",
    "accent": "#002FA7",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-ikb",
      "style": "swiss",
      "name": "克莱因蓝",
      "accent": "#002FA7",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-lemon:paper": {
    "style": "swiss",
    "bg": "paper",
    "page": "#FAFAF8",
    "text": "#0A0A0A",
    "sub": "#737373",
    "hairline": "#D4D4D2",
    "accent": "#FFD500",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-lemon",
      "style": "swiss",
      "name": "柠檬黄",
      "accent": "#FFD500",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-lemon:ink": {
    "style": "swiss",
    "bg": "ink",
    "page": "#0A0A0A",
    "text": "#FAFAF8",
    "sub": "#D4D4D2",
    "hairline": "#737373",
    "accent": "#FFD500",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-lemon",
      "style": "swiss",
      "name": "柠檬黄",
      "accent": "#FFD500",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-lemon:accent": {
    "style": "swiss",
    "bg": "accent",
    "page": "#FFD500",
    "text": "#0A0A0A",
    "sub": "#0A0A0A",
    "hairline": "#0A0A0A",
    "accent": "#FFD500",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-lemon",
      "style": "swiss",
      "name": "柠檬黄",
      "accent": "#FFD500",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-green:paper": {
    "style": "swiss",
    "bg": "paper",
    "page": "#FAFAF8",
    "text": "#0A0A0A",
    "sub": "#737373",
    "hairline": "#D4D4D2",
    "accent": "#C5E803",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-green",
      "style": "swiss",
      "name": "柠檬绿",
      "accent": "#C5E803",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-green:ink": {
    "style": "swiss",
    "bg": "ink",
    "page": "#0A0A0A",
    "text": "#FAFAF8",
    "sub": "#D4D4D2",
    "hairline": "#737373",
    "accent": "#C5E803",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-green",
      "style": "swiss",
      "name": "柠檬绿",
      "accent": "#C5E803",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-green:accent": {
    "style": "swiss",
    "bg": "accent",
    "page": "#C5E803",
    "text": "#0A0A0A",
    "sub": "#0A0A0A",
    "hairline": "#0A0A0A",
    "accent": "#C5E803",
    "accentOn": "#0A0A0A",
    "accentOnBold": false,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-green",
      "style": "swiss",
      "name": "柠檬绿",
      "accent": "#C5E803",
      "accentOn": "#0A0A0A",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-orange:paper": {
    "style": "swiss",
    "bg": "paper",
    "page": "#FAFAF8",
    "text": "#0A0A0A",
    "sub": "#737373",
    "hairline": "#D4D4D2",
    "accent": "#FF6B35",
    "accentOn": "#FFFFFF",
    "accentOnBold": true,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-orange",
      "style": "swiss",
      "name": "安全橙",
      "accent": "#FF6B35",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-orange:ink": {
    "style": "swiss",
    "bg": "ink",
    "page": "#0A0A0A",
    "text": "#FAFAF8",
    "sub": "#D4D4D2",
    "hairline": "#737373",
    "accent": "#FF6B35",
    "accentOn": "#FFFFFF",
    "accentOnBold": true,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-orange",
      "style": "swiss",
      "name": "安全橙",
      "accent": "#FF6B35",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "swiss-orange:accent": {
    "style": "swiss",
    "bg": "accent",
    "page": "#FF6B35",
    "text": "#FFFFFF",
    "sub": "#FFFFFF",
    "hairline": "#FFFFFF",
    "accent": "#FF6B35",
    "accentOn": "#FFFFFF",
    "accentOnBold": true,
    "fontHead": "Microsoft YaHei Light",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Segoe UI Light",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#F0F0EE",
    "pageDeep": "#0A0A0A",
    "theme": {
      "id": "swiss-orange",
      "style": "swiss",
      "name": "安全橙",
      "accent": "#FF6B35",
      "accentOn": "#FFFFFF",
      "grey": {
        "paper": "#FAFAF8",
        "grey1": "#F0F0EE",
        "grey2": "#D4D4D2",
        "grey3": "#737373",
        "ink": "#0A0A0A"
      }
    }
  },
  "mag-classic:paper": {
    "style": "magazine",
    "bg": "paper",
    "page": "#F1EFEA",
    "text": "#0A0A0B",
    "sub": "#0A0A0B",
    "hairline": "#E8E5DE",
    "accent": "#0A0A0B",
    "accentOn": "#F1EFEA",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E8E5DE",
    "pageDeep": "#0A0A0B",
    "theme": {
      "id": "mag-classic",
      "style": "magazine",
      "name": "墨水经典",
      "ink": "#0A0A0B",
      "paper": "#F1EFEA",
      "paperTint": "#E8E5DE"
    }
  },
  "mag-classic:ink": {
    "style": "magazine",
    "bg": "ink",
    "page": "#0A0A0B",
    "text": "#F1EFEA",
    "sub": "#E8E5DE",
    "hairline": "#E8E5DE",
    "accent": "#0A0A0B",
    "accentOn": "#F1EFEA",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E8E5DE",
    "pageDeep": "#0A0A0B",
    "theme": {
      "id": "mag-classic",
      "style": "magazine",
      "name": "墨水经典",
      "ink": "#0A0A0B",
      "paper": "#F1EFEA",
      "paperTint": "#E8E5DE"
    }
  },
  "mag-classic:accent": {
    "style": "magazine",
    "bg": "accent",
    "page": "#0A0A0B",
    "text": "#F1EFEA",
    "sub": "#E8E5DE",
    "hairline": "#E8E5DE",
    "accent": "#0A0A0B",
    "accentOn": "#F1EFEA",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E8E5DE",
    "pageDeep": "#0A0A0B",
    "theme": {
      "id": "mag-classic",
      "style": "magazine",
      "name": "墨水经典",
      "ink": "#0A0A0B",
      "paper": "#F1EFEA",
      "paperTint": "#E8E5DE"
    }
  },
  "mag-indigo:paper": {
    "style": "magazine",
    "bg": "paper",
    "page": "#F1F3F5",
    "text": "#0A1F3D",
    "sub": "#0A1F3D",
    "hairline": "#E4E8EC",
    "accent": "#0A1F3D",
    "accentOn": "#F1F3F5",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E4E8EC",
    "pageDeep": "#0A1F3D",
    "theme": {
      "id": "mag-indigo",
      "style": "magazine",
      "name": "靛蓝瓷",
      "ink": "#0A1F3D",
      "paper": "#F1F3F5",
      "paperTint": "#E4E8EC"
    }
  },
  "mag-indigo:ink": {
    "style": "magazine",
    "bg": "ink",
    "page": "#0A1F3D",
    "text": "#F1F3F5",
    "sub": "#E4E8EC",
    "hairline": "#E4E8EC",
    "accent": "#0A1F3D",
    "accentOn": "#F1F3F5",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E4E8EC",
    "pageDeep": "#0A1F3D",
    "theme": {
      "id": "mag-indigo",
      "style": "magazine",
      "name": "靛蓝瓷",
      "ink": "#0A1F3D",
      "paper": "#F1F3F5",
      "paperTint": "#E4E8EC"
    }
  },
  "mag-indigo:accent": {
    "style": "magazine",
    "bg": "accent",
    "page": "#0A1F3D",
    "text": "#F1F3F5",
    "sub": "#E4E8EC",
    "hairline": "#E4E8EC",
    "accent": "#0A1F3D",
    "accentOn": "#F1F3F5",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E4E8EC",
    "pageDeep": "#0A1F3D",
    "theme": {
      "id": "mag-indigo",
      "style": "magazine",
      "name": "靛蓝瓷",
      "ink": "#0A1F3D",
      "paper": "#F1F3F5",
      "paperTint": "#E4E8EC"
    }
  },
  "mag-forest:paper": {
    "style": "magazine",
    "bg": "paper",
    "page": "#F5F1E8",
    "text": "#1A2E1F",
    "sub": "#1A2E1F",
    "hairline": "#ECE7DA",
    "accent": "#1A2E1F",
    "accentOn": "#F5F1E8",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#ECE7DA",
    "pageDeep": "#1A2E1F",
    "theme": {
      "id": "mag-forest",
      "style": "magazine",
      "name": "森林墨",
      "ink": "#1A2E1F",
      "paper": "#F5F1E8",
      "paperTint": "#ECE7DA"
    }
  },
  "mag-forest:ink": {
    "style": "magazine",
    "bg": "ink",
    "page": "#1A2E1F",
    "text": "#F5F1E8",
    "sub": "#ECE7DA",
    "hairline": "#ECE7DA",
    "accent": "#1A2E1F",
    "accentOn": "#F5F1E8",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#ECE7DA",
    "pageDeep": "#1A2E1F",
    "theme": {
      "id": "mag-forest",
      "style": "magazine",
      "name": "森林墨",
      "ink": "#1A2E1F",
      "paper": "#F5F1E8",
      "paperTint": "#ECE7DA"
    }
  },
  "mag-forest:accent": {
    "style": "magazine",
    "bg": "accent",
    "page": "#1A2E1F",
    "text": "#F5F1E8",
    "sub": "#ECE7DA",
    "hairline": "#ECE7DA",
    "accent": "#1A2E1F",
    "accentOn": "#F5F1E8",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#ECE7DA",
    "pageDeep": "#1A2E1F",
    "theme": {
      "id": "mag-forest",
      "style": "magazine",
      "name": "森林墨",
      "ink": "#1A2E1F",
      "paper": "#F5F1E8",
      "paperTint": "#ECE7DA"
    }
  },
  "mag-kraft:paper": {
    "style": "magazine",
    "bg": "paper",
    "page": "#EEDFC7",
    "text": "#2A1E13",
    "sub": "#2A1E13",
    "hairline": "#E0D0B6",
    "accent": "#2A1E13",
    "accentOn": "#EEDFC7",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E0D0B6",
    "pageDeep": "#2A1E13",
    "theme": {
      "id": "mag-kraft",
      "style": "magazine",
      "name": "牛皮纸",
      "ink": "#2A1E13",
      "paper": "#EEDFC7",
      "paperTint": "#E0D0B6"
    }
  },
  "mag-kraft:ink": {
    "style": "magazine",
    "bg": "ink",
    "page": "#2A1E13",
    "text": "#EEDFC7",
    "sub": "#E0D0B6",
    "hairline": "#E0D0B6",
    "accent": "#2A1E13",
    "accentOn": "#EEDFC7",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E0D0B6",
    "pageDeep": "#2A1E13",
    "theme": {
      "id": "mag-kraft",
      "style": "magazine",
      "name": "牛皮纸",
      "ink": "#2A1E13",
      "paper": "#EEDFC7",
      "paperTint": "#E0D0B6"
    }
  },
  "mag-kraft:accent": {
    "style": "magazine",
    "bg": "accent",
    "page": "#2A1E13",
    "text": "#EEDFC7",
    "sub": "#E0D0B6",
    "hairline": "#E0D0B6",
    "accent": "#2A1E13",
    "accentOn": "#EEDFC7",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E0D0B6",
    "pageDeep": "#2A1E13",
    "theme": {
      "id": "mag-kraft",
      "style": "magazine",
      "name": "牛皮纸",
      "ink": "#2A1E13",
      "paper": "#EEDFC7",
      "paperTint": "#E0D0B6"
    }
  },
  "mag-dune:paper": {
    "style": "magazine",
    "bg": "paper",
    "page": "#F0E6D2",
    "text": "#1F1A14",
    "sub": "#1F1A14",
    "hairline": "#E3D7BF",
    "accent": "#1F1A14",
    "accentOn": "#F0E6D2",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E3D7BF",
    "pageDeep": "#1F1A14",
    "theme": {
      "id": "mag-dune",
      "style": "magazine",
      "name": "沙丘",
      "ink": "#1F1A14",
      "paper": "#F0E6D2",
      "paperTint": "#E3D7BF"
    }
  },
  "mag-dune:ink": {
    "style": "magazine",
    "bg": "ink",
    "page": "#1F1A14",
    "text": "#F0E6D2",
    "sub": "#E3D7BF",
    "hairline": "#E3D7BF",
    "accent": "#1F1A14",
    "accentOn": "#F0E6D2",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E3D7BF",
    "pageDeep": "#1F1A14",
    "theme": {
      "id": "mag-dune",
      "style": "magazine",
      "name": "沙丘",
      "ink": "#1F1A14",
      "paper": "#F0E6D2",
      "paperTint": "#E3D7BF"
    }
  },
  "mag-dune:accent": {
    "style": "magazine",
    "bg": "accent",
    "page": "#1F1A14",
    "text": "#F0E6D2",
    "sub": "#E3D7BF",
    "hairline": "#E3D7BF",
    "accent": "#1F1A14",
    "accentOn": "#F0E6D2",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 33,
      "dataHero": 63,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#E3D7BF",
    "pageDeep": "#1F1A14",
    "theme": {
      "id": "mag-dune",
      "style": "magazine",
      "name": "沙丘",
      "ink": "#1F1A14",
      "paper": "#F0E6D2",
      "paperTint": "#E3D7BF"
    }
  },
  "luxe-noir:paper": {
    "style": "luxe",
    "bg": "paper",
    "page": "#F5F1EC",
    "text": "#1A1A1A",
    "sub": "#888888",
    "hairline": "#BBBBBB",
    "accent": "#C4937A",
    "accentOn": "#1A1A1A",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Cambria",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 52,
      "pageTitle": 34,
      "dataHero": 66,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#EDD5CA",
    "pageDeep": "#0D0D0D",
    "theme": {
      "id": "luxe-noir",
      "style": "luxe",
      "name": "暗夜轻奢",
      "ink": "#1A1A1A",
      "paper": "#F5F1EC",
      "inkDeep": "#0D0D0D",
      "accent": "#C4937A",
      "accentOn": "#1A1A1A",
      "blush": "#EDD5CA",
      "grey2": "#888888"
    }
  },
  "luxe-noir:ink": {
    "style": "luxe",
    "bg": "ink",
    "page": "#1A1A1A",
    "text": "#F5F1EC",
    "sub": "#BBBBBB",
    "hairline": "#888888",
    "accent": "#C4937A",
    "accentOn": "#1A1A1A",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Cambria",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 52,
      "pageTitle": 34,
      "dataHero": 66,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#EDD5CA",
    "pageDeep": "#0D0D0D",
    "theme": {
      "id": "luxe-noir",
      "style": "luxe",
      "name": "暗夜轻奢",
      "ink": "#1A1A1A",
      "paper": "#F5F1EC",
      "inkDeep": "#0D0D0D",
      "accent": "#C4937A",
      "accentOn": "#1A1A1A",
      "blush": "#EDD5CA",
      "grey2": "#888888"
    }
  },
  "luxe-noir:accent": {
    "style": "luxe",
    "bg": "accent",
    "page": "#0D0D0D",
    "text": "#F5F1EC",
    "sub": "#BBBBBB",
    "hairline": "#888888",
    "accent": "#C4937A",
    "accentOn": "#1A1A1A",
    "accentOnBold": false,
    "fontHead": "Noto Serif SC",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Cambria",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 52,
      "pageTitle": 34,
      "dataHero": 66,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": true,
    "ruleW": 1,
    "blush": "#EDD5CA",
    "pageDeep": "#0D0D0D",
    "theme": {
      "id": "luxe-noir",
      "style": "luxe",
      "name": "暗夜轻奢",
      "ink": "#1A1A1A",
      "paper": "#F5F1EC",
      "inkDeep": "#0D0D0D",
      "accent": "#C4937A",
      "accentOn": "#1A1A1A",
      "blush": "#EDD5CA",
      "grey2": "#888888"
    }
  },
  "consult-navy:paper": {
    "style": "consult",
    "bg": "paper",
    "page": "#FFFFFF",
    "text": "#1A2B45",
    "sub": "#5A6B82",
    "hairline": "#5A6B82",
    "accent": "#1A2B45",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial",
    "fontBody": "Arial",
    "fontHero": "Arial",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 32,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.16,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#FFFFFF",
    "pageDeep": "#1A2B45",
    "theme": {
      "id": "consult-navy",
      "style": "consult",
      "name": "咨询蓝",
      "paper": "#FFFFFF",
      "ink": "#1A2B45",
      "muted": "#5A6B82",
      "accent": "#1A2B45",
      "accentOn": "#FFFFFF",
      "accentEmerald": "#1F8A70",
      "accentGold": "#C9A227",
      "accentCoral": "#C0492E",
      "accentSlate": "#64748B"
    }
  },
  "consult-navy:ink": {
    "style": "consult",
    "bg": "ink",
    "page": "#1A2B45",
    "text": "#FFFFFF",
    "sub": "#5A6B82",
    "hairline": "#5A6B82",
    "accent": "#1A2B45",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial",
    "fontBody": "Arial",
    "fontHero": "Arial",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 32,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.16,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#FFFFFF",
    "pageDeep": "#1A2B45",
    "theme": {
      "id": "consult-navy",
      "style": "consult",
      "name": "咨询蓝",
      "paper": "#FFFFFF",
      "ink": "#1A2B45",
      "muted": "#5A6B82",
      "accent": "#1A2B45",
      "accentOn": "#FFFFFF",
      "accentEmerald": "#1F8A70",
      "accentGold": "#C9A227",
      "accentCoral": "#C0492E",
      "accentSlate": "#64748B"
    }
  },
  "consult-navy:accent": {
    "style": "consult",
    "bg": "accent",
    "page": "#1A2B45",
    "text": "#FFFFFF",
    "sub": "#5A6B82",
    "hairline": "#5A6B82",
    "accent": "#1A2B45",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial",
    "fontBody": "Arial",
    "fontHero": "Arial",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 48,
      "pageTitle": 32,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.16,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#FFFFFF",
    "pageDeep": "#1A2B45",
    "theme": {
      "id": "consult-navy",
      "style": "consult",
      "name": "咨询蓝",
      "paper": "#FFFFFF",
      "ink": "#1A2B45",
      "muted": "#5A6B82",
      "accent": "#1A2B45",
      "accentOn": "#FFFFFF",
      "accentEmerald": "#1F8A70",
      "accentGold": "#C9A227",
      "accentCoral": "#C0492E",
      "accentSlate": "#64748B"
    }
  },
  "brutal-paper:paper": {
    "style": "brutal",
    "bg": "paper",
    "page": "#FFFFFF",
    "text": "#111111",
    "sub": "#3A3A3A",
    "hairline": "#111111",
    "accent": "#C8102E",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 38,
      "dataHero": 76,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 3,
    "blush": "#FFFFFF",
    "pageDeep": "#111111",
    "theme": {
      "id": "brutal-paper",
      "style": "brutal",
      "name": "粗野报纸",
      "paper": "#FFFFFF",
      "ink": "#111111",
      "muted": "#3A3A3A",
      "accent": "#C8102E",
      "accentOn": "#FFFFFF"
    }
  },
  "brutal-paper:ink": {
    "style": "brutal",
    "bg": "ink",
    "page": "#111111",
    "text": "#FFFFFF",
    "sub": "#FFFFFF",
    "hairline": "#FFFFFF",
    "accent": "#C8102E",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 38,
      "dataHero": 76,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 3,
    "blush": "#FFFFFF",
    "pageDeep": "#111111",
    "theme": {
      "id": "brutal-paper",
      "style": "brutal",
      "name": "粗野报纸",
      "paper": "#FFFFFF",
      "ink": "#111111",
      "muted": "#3A3A3A",
      "accent": "#C8102E",
      "accentOn": "#FFFFFF"
    }
  },
  "brutal-paper:accent": {
    "style": "brutal",
    "bg": "accent",
    "page": "#111111",
    "text": "#FFFFFF",
    "sub": "#FFFFFF",
    "hairline": "#FFFFFF",
    "accent": "#C8102E",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 60,
      "pageTitle": 38,
      "dataHero": 76,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 3,
    "blush": "#FFFFFF",
    "pageDeep": "#111111",
    "theme": {
      "id": "brutal-paper",
      "style": "brutal",
      "name": "粗野报纸",
      "paper": "#FFFFFF",
      "ink": "#111111",
      "muted": "#3A3A3A",
      "accent": "#C8102E",
      "accentOn": "#FFFFFF"
    }
  },
  "term-phosphor:paper": {
    "style": "term",
    "bg": "paper",
    "page": "#0A0F0A",
    "text": "#C8F0C8",
    "sub": "#5A825A",
    "hairline": "#5A825A",
    "accent": "#33FF66",
    "accentOn": "#0A0F0A",
    "accentOnBold": false,
    "fontHead": "Consolas",
    "fontBody": "Consolas",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 44,
      "pageTitle": 30,
      "dataHero": 58,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#0A0F0A",
    "pageDeep": "#000000",
    "theme": {
      "id": "term-phosphor",
      "style": "term",
      "name": "终端磷光",
      "paper": "#0A0F0A",
      "ink": "#C8F0C8",
      "muted": "#5A825A",
      "inkDeep": "#000000",
      "accent": "#33FF66",
      "accentOn": "#0A0F0A",
      "accentAmber": "#FFB000",
      "accentBlue": "#5AC8FF",
      "accentRed": "#FF5A5A"
    }
  },
  "term-phosphor:ink": {
    "style": "term",
    "bg": "ink",
    "page": "#000000",
    "text": "#C8F0C8",
    "sub": "#5A825A",
    "hairline": "#5A825A",
    "accent": "#33FF66",
    "accentOn": "#0A0F0A",
    "accentOnBold": false,
    "fontHead": "Consolas",
    "fontBody": "Consolas",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 44,
      "pageTitle": 30,
      "dataHero": 58,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#0A0F0A",
    "pageDeep": "#000000",
    "theme": {
      "id": "term-phosphor",
      "style": "term",
      "name": "终端磷光",
      "paper": "#0A0F0A",
      "ink": "#C8F0C8",
      "muted": "#5A825A",
      "inkDeep": "#000000",
      "accent": "#33FF66",
      "accentOn": "#0A0F0A",
      "accentAmber": "#FFB000",
      "accentBlue": "#5AC8FF",
      "accentRed": "#FF5A5A"
    }
  },
  "term-phosphor:accent": {
    "style": "term",
    "bg": "accent",
    "page": "#000000",
    "text": "#C8F0C8",
    "sub": "#5A825A",
    "hairline": "#5A825A",
    "accent": "#33FF66",
    "accentOn": "#0A0F0A",
    "accentOnBold": false,
    "fontHead": "Consolas",
    "fontBody": "Consolas",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 44,
      "pageTitle": 30,
      "dataHero": 58,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 1,
    "blush": "#0A0F0A",
    "pageDeep": "#000000",
    "theme": {
      "id": "term-phosphor",
      "style": "term",
      "name": "终端磷光",
      "paper": "#0A0F0A",
      "ink": "#C8F0C8",
      "muted": "#5A825A",
      "inkDeep": "#000000",
      "accent": "#33FF66",
      "accentOn": "#0A0F0A",
      "accentAmber": "#FFB000",
      "accentBlue": "#5AC8FF",
      "accentRed": "#FF5A5A"
    }
  },
  "report-ft:paper": {
    "style": "report",
    "bg": "paper",
    "page": "#0E0E12",
    "text": "#ECECEF",
    "sub": "#8C8C97",
    "hairline": "#8C8C97",
    "accent": "#D9A441",
    "accentOn": "#0E0E12",
    "accentOnBold": false,
    "fontHead": "Georgia",
    "fontBody": "Arial",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 50,
      "pageTitle": 33,
      "dataHero": 64,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 0.7,
    "blush": "#0E0E12",
    "pageDeep": "#000000",
    "theme": {
      "id": "report-ft",
      "style": "report",
      "name": "研报深墨",
      "paper": "#0E0E12",
      "ink": "#ECECEF",
      "muted": "#8C8C97",
      "inkDeep": "#000000",
      "accent": "#D9A441",
      "accentOn": "#0E0E12",
      "accentRed": "#E0392B"
    }
  },
  "report-ft:ink": {
    "style": "report",
    "bg": "ink",
    "page": "#000000",
    "text": "#ECECEF",
    "sub": "#8C8C97",
    "hairline": "#8C8C97",
    "accent": "#D9A441",
    "accentOn": "#0E0E12",
    "accentOnBold": false,
    "fontHead": "Georgia",
    "fontBody": "Arial",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 50,
      "pageTitle": 33,
      "dataHero": 64,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 0.7,
    "blush": "#0E0E12",
    "pageDeep": "#000000",
    "theme": {
      "id": "report-ft",
      "style": "report",
      "name": "研报深墨",
      "paper": "#0E0E12",
      "ink": "#ECECEF",
      "muted": "#8C8C97",
      "inkDeep": "#000000",
      "accent": "#D9A441",
      "accentOn": "#0E0E12",
      "accentRed": "#E0392B"
    }
  },
  "report-ft:accent": {
    "style": "report",
    "bg": "accent",
    "page": "#000000",
    "text": "#ECECEF",
    "sub": "#8C8C97",
    "hairline": "#8C8C97",
    "accent": "#D9A441",
    "accentOn": "#0E0E12",
    "accentOnBold": false,
    "fontHead": "Georgia",
    "fontBody": "Arial",
    "fontHero": "Consolas",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 50,
      "pageTitle": 33,
      "dataHero": 64,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.08,
    "serifHead": true,
    "ruleW": 0.7,
    "blush": "#0E0E12",
    "pageDeep": "#000000",
    "theme": {
      "id": "report-ft",
      "style": "report",
      "name": "研报深墨",
      "paper": "#0E0E12",
      "ink": "#ECECEF",
      "muted": "#8C8C97",
      "inkDeep": "#000000",
      "accent": "#D9A441",
      "accentOn": "#0E0E12",
      "accentRed": "#E0392B"
    }
  },
  "ink-zhu:paper": {
    "style": "ink",
    "bg": "paper",
    "page": "#F5F1E8",
    "text": "#1A1A1A",
    "sub": "#8B8680",
    "hairline": "#8B8680",
    "accent": "#A52A2A",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "KaiTi",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 54,
      "pageTitle": 34,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 0.5,
    "blush": "#F5F1E8",
    "pageDeep": "#1A1A1A",
    "theme": {
      "id": "ink-zhu",
      "style": "ink",
      "name": "水墨朱印",
      "paper": "#F5F1E8",
      "ink": "#1A1A1A",
      "muted": "#8B8680",
      "accent": "#A52A2A",
      "accentOn": "#FFFFFF",
      "accentGrey": "#5C5852"
    }
  },
  "ink-zhu:ink": {
    "style": "ink",
    "bg": "ink",
    "page": "#1A1A1A",
    "text": "#F5F1E8",
    "sub": "#8B8680",
    "hairline": "#8B8680",
    "accent": "#A52A2A",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "KaiTi",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 54,
      "pageTitle": 34,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 0.5,
    "blush": "#F5F1E8",
    "pageDeep": "#1A1A1A",
    "theme": {
      "id": "ink-zhu",
      "style": "ink",
      "name": "水墨朱印",
      "paper": "#F5F1E8",
      "ink": "#1A1A1A",
      "muted": "#8B8680",
      "accent": "#A52A2A",
      "accentOn": "#FFFFFF",
      "accentGrey": "#5C5852"
    }
  },
  "ink-zhu:accent": {
    "style": "ink",
    "bg": "accent",
    "page": "#1A1A1A",
    "text": "#F5F1E8",
    "sub": "#8B8680",
    "hairline": "#8B8680",
    "accent": "#A52A2A",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "KaiTi",
    "fontBody": "Microsoft YaHei",
    "fontHero": "Georgia",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 54,
      "pageTitle": 34,
      "dataHero": 60,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0,
    "serifHead": false,
    "ruleW": 0.5,
    "blush": "#F5F1E8",
    "pageDeep": "#1A1A1A",
    "theme": {
      "id": "ink-zhu",
      "style": "ink",
      "name": "水墨朱印",
      "paper": "#F5F1E8",
      "ink": "#1A1A1A",
      "muted": "#8B8680",
      "accent": "#A52A2A",
      "accentOn": "#FFFFFF",
      "accentGrey": "#5C5852"
    }
  },
  "memphis-pop:paper": {
    "style": "memphis",
    "bg": "paper",
    "page": "#FCF2D8",
    "text": "#1A1A17",
    "sub": "#9A9384",
    "hairline": "#9A9384",
    "accent": "#F76302",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 56,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.32,
    "serifHead": false,
    "ruleW": 1.2,
    "blush": "#FCF2D8",
    "pageDeep": "#1A1A17",
    "theme": {
      "id": "memphis-pop",
      "style": "memphis",
      "name": "孟菲斯",
      "paper": "#FCF2D8",
      "ink": "#1A1A17",
      "muted": "#9A9384",
      "accent": "#F76302",
      "accentOn": "#FFFFFF",
      "accentBlue": "#0548C5",
      "accentRed": "#E2342B",
      "accentGreen": "#1B7A3D",
      "accentYellow": "#F6BE1A"
    }
  },
  "memphis-pop:ink": {
    "style": "memphis",
    "bg": "ink",
    "page": "#1A1A17",
    "text": "#FCF2D8",
    "sub": "#9A9384",
    "hairline": "#9A9384",
    "accent": "#F76302",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 56,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.32,
    "serifHead": false,
    "ruleW": 1.2,
    "blush": "#FCF2D8",
    "pageDeep": "#1A1A17",
    "theme": {
      "id": "memphis-pop",
      "style": "memphis",
      "name": "孟菲斯",
      "paper": "#FCF2D8",
      "ink": "#1A1A17",
      "muted": "#9A9384",
      "accent": "#F76302",
      "accentOn": "#FFFFFF",
      "accentBlue": "#0548C5",
      "accentRed": "#E2342B",
      "accentGreen": "#1B7A3D",
      "accentYellow": "#F6BE1A"
    }
  },
  "memphis-pop:accent": {
    "style": "memphis",
    "bg": "accent",
    "page": "#1A1A17",
    "text": "#FCF2D8",
    "sub": "#9A9384",
    "hairline": "#9A9384",
    "accent": "#F76302",
    "accentOn": "#FFFFFF",
    "accentOnBold": false,
    "fontHead": "Arial Black",
    "fontBody": "Arial",
    "fontHero": "Arial Black",
    "fontMono": "Consolas",
    "scale": {
      "coverTitle": 56,
      "pageTitle": 36,
      "dataHero": 70,
      "sectionHead": 18,
      "body": 14.5,
      "caption": 12,
      "meta": 9.5
    },
    "radius": 0.32,
    "serifHead": false,
    "ruleW": 1.2,
    "blush": "#FCF2D8",
    "pageDeep": "#1A1A17",
    "theme": {
      "id": "memphis-pop",
      "style": "memphis",
      "name": "孟菲斯",
      "paper": "#FCF2D8",
      "ink": "#1A1A17",
      "muted": "#9A9384",
      "accent": "#F76302",
      "accentOn": "#FFFFFF",
      "accentBlue": "#0548C5",
      "accentRed": "#E2342B",
      "accentGreen": "#1B7A3D",
      "accentYellow": "#F6BE1A"
    }
  }
} as unknown as Record<string, V2Skin>;

export function v2Skin(themeId: string, bg: "paper" | "ink" | "accent"): V2Skin {
  return V2SKINS[themeId + ":" + bg] ?? V2SKINS["swiss-ikb:paper"];
}
